import * as constants from '../constants/tags'

const defaultState = {
  tags: [],
  regions: [],
  allTags: [],
  tag: {},
  complianceRatings: [],
  tagsComplianceRatings: [],
  managers: [],
  requestSuccess: false,
  requestType: ''
}

export default (state = defaultState, action) => {
  var newState = {...state}

  switch (action.type){
    case constants.GET_TAGS_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_TAGS_SUCCESS:
      newState.requestType = action.type;
      newState.tags = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_TAGS_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_CATEGORIZED_TAGS_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_CATEGORIZED_TAGS_SUCCESS:
      newState.requestType = action.type;
      newState.allTags = action.body.all_tags;
      newState.tags = action.body.tags;
      newState.regions = action.body.regions;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_CATEGORIZED_TAGS_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_TAG_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_TAG_SUCCESS:
      newState.tag = action.body;
      newState.managers = action.body.managers
      newState.requestSuccess = true;
      return newState;
    case constants.GET_TAG_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_SUCCESS:
      newState.complianceRatings = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_COMPLIANCE_RATINGS_FAILURE:
      newState = defaultState;
      return newState;
    case constants.UPDATE_TAG_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.UPDATE_TAG_SUCCESS:
      newState.requestType = action.type;
      newState.requestSuccess = true;
      newState.managers = action.body.managers;
      return newState;
    case constants.UPDATE_TAG_FAILURE:
      newState = defaultState;
      return newState;
    case constants.CREATE_TAG_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.CREATE_TAG_SUCCESS:
      newState.requestType = action.type;
      newState.tag = action.body;
      newState.managers = action.body.managers;
      newState.requestSuccess = true;
      return newState;
    case constants.CREATE_TAG_FAILURE:
      newState = defaultState;
      return newState;
    case constants.GET_TAGS_COMPLIANCE_RATINGS_REQUEST:
      newState.requestType = action.type;
      newState.requestSuccess = false;
      return newState;
    case constants.GET_TAGS_COMPLIANCE_RATINGS_SUCCESS:
      newState.tagsComplianceRatings = action.body;
      newState.requestSuccess = true;
      return newState;
    case constants.GET_TAGS_COMPLIANCE_RATINGS_FAILURE:
      newState = defaultState;
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tags.js